<div #greInvisibleElement [ngClass]="{ 'captcha-active': captchaActive }"></div>
<div #greElement [ngClass]="{ 'captcha-active': captchaActive }"></div>
